import {
  SET_SOLICITUD_ID,
  ADD_AUTORIZACION_LISTA_SOLICITUDES,
  REFRESCAR_ULTIMAS_AUTORIZACIONES,
  CANCELAR_AUTORIZACION,
  ERROR_AUTORIZACIONES_POST,
  REFRESCAR_ULTIMAS_AUTORIZACIONES_INICIO,
  REFRESCAR_ULTIMAS_AUTORIZACIONES_ERROR,
} from "../types";

const initialState = {
  solicitudID: null,
  listado: [],
  listadoAutorizacionSolicitud: [],
  error: null,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SOLICITUD_ID: {
      return {
        ...state,
        solicitudID: action.payload.data.id,
      };
    }
    case ADD_AUTORIZACION_LISTA_SOLICITUDES: {
      return {
        ...state,
        listadoAutorizacionSolicitud: action.payload,
        error: null,
      };
    }
    case REFRESCAR_ULTIMAS_AUTORIZACIONES_INICIO: {
      return {
        ...state,
        loading: true,
      };
    }
    case REFRESCAR_ULTIMAS_AUTORIZACIONES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case REFRESCAR_ULTIMAS_AUTORIZACIONES: {
      return {
        ...state,
        listado: action.payload,
        loading: false,
      };
    }
    case CANCELAR_AUTORIZACION: {
      return {
        ...state,
        listado: state.listado.filter((p) => p.id !== action.payload.id),
        error: null,
      };
    }
    case ERROR_AUTORIZACIONES_POST: {
      return {
        ...state,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
